import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames/bind';
import styles from './AdminDashboardPage.module.css';
import { ToastContext } from '~/components/context/ToastContext';
import { ModalContext } from '~/components/context/ModalContext';
import { BASE_TRANSACTIONS_URL } from '~/helper/apiService';

const cx = classNames.bind(styles);

function RedeemPoints() {
  const [phone, setPhone] = useState('');
  const [customerPoints, setCustomerPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { showToast } = useContext(ToastContext);
  const { showModal } = useContext(ModalContext);

  useEffect(() => {
    const fetchCustomerPoints = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_TRANSACTIONS_URL}get-customer-points`, {
          credentials: 'include',
        });
        const data = await response.json();
        if (response.ok) {
          setCustomerPoints(data.customerPoints || []);
        } else {
          showToast(data.error || 'Lỗi khi lấy dữ liệu tổng điểm khách hàng', 'error');
        }
      } catch (err) {
        showToast('Lỗi kết nối đến server', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerPoints();
  }, []);

  const handleRedeem = async () => {
    try {
      const response = await fetch(`${BASE_TRANSACTIONS_URL}redeem-point`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone }),credentials: 'include',
      });

      const data = await response.json();
      if (response.ok) {
        showToast(data.message, 'success');
        setPhone('');
        // Refresh customer points after redeeming
        const refreshResponse = await fetch(`${BASE_TRANSACTIONS_URL}get-customer-points`, {
          credentials: 'include',
        });
        const refreshData = await refreshResponse.json();
        if (refreshResponse.ok) {
          setCustomerPoints(refreshData.customerPoints || []);
        }
      } else {
        showToast(data.error || 'Có lỗi xảy ra', 'error');
        return false; // Keep modal open on error
      }
    } catch (error) {
      showToast('Lỗi kết nối: ' + error.message, 'error');
      return false; // Keep modal open on error
    }
  };

  const confirmRedeem = () => {
    if (!phone) {
      showToast('Vui lòng nhập số điện thoại', 'error');
      return;
    }
    showModal({
      title: 'Xác Nhận Đổi Điểm',
      message: `Bạn có chắc chắn muốn đổi điểm cho số điện thoại ${phone}?`,
      onConfirm: handleRedeem,
      onCancel: null, // Uses default hideModal from ModalContext
    });
  };

  const handleCustomerClick = (phoneNumber) => {
    setPhone(phoneNumber);
  };

  return (
    <div className={cx('redeem-section')}>
      <div className={cx('search-form')}>
        <input
          type="text"
          placeholder="Nhập số điện thoại"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={cx('input')}
        />
        <button
          onClick={confirmRedeem}
          className={cx('button')}
        >
          Đổi Điểm
        </button>
      </div>
      <div className={cx('customer-points-section')}>
        <h2 className={cx('subtitle')}>Danh Sách Tổng Điểm Khách Hàng</h2>
        {loading && <div className={cx('loading')}>Đang tải...</div>}
        {error && (
          <div className={cx('message', 'error')}>
            {error}
          </div>
        )}
        {!loading && !error && customerPoints.length === 0 && (
          <div className={cx('no-data')}>Không có dữ liệu tổng điểm khách hàng</div>
        )}
        {!loading && !error && customerPoints.length > 0 && (
          <table className={cx('table')}>
            <thead>
              <tr className={cx('tr')}>
                <th className={cx('th')}>Thời gian</th>
                <th className={cx('th')}>Số điện thoại</th>
                <th className={cx('th')}>Tổng điểm</th>
              </tr>
            </thead>
            <tbody>
              {customerPoints.map((point, index) => (
                <tr key={index} className={cx('tr')}>
                  <td className={cx('td')}>{point.timestamp}</td>
                  <td
                    className={cx('td', 'clickable')}
                    onClick={() => handleCustomerClick(point.phone)}
                    style={{ cursor: 'pointer', color: '#4caf50', textDecoration: 'underline' }}
                  >
                    {point.phone}
                  </td>
                  <td
                    className={cx('td', {
                      positive: point.totalPoints > 0,
                      negative: point.totalPoints < 0,
                    })}
                  >
                    {point.totalPoints}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default RedeemPoints;